import React from 'react';
// import { Link } from 'react-router-dom';
import { FaWhatsapp, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import './index.css';


const Footer = ({ showDesignCredit = false }) => {
  return (
    <>
      {/* Let's Build Together CTA Section */}

      {/*       
      <section className="aboutpage-cta">
        <div className="aboutpage-cta-content">
          <h2 className="aboutpage-cta-title">LET'S BUILD TOGETHER</h2>
          <div className="aboutpage-cta-text">
            <p>
              Whether it's a home, a workplace, or a cultural landmark, we create environments that feel <br/> alive and purposeful. <br/> Let's begin a dialogue that shapes more than just structures—it shapes experiences.
            </p>
          </div>
          <Link to="/contact" className="aboutpage-cta-button">
            START A CONVERSATION
          </Link>
        </div>
      </section> */}

      {/* Footer Section */}
      <footer className="contactpage-footer">
        <div className="contactpage-footer-content">
          <p className="contactpage-copyright">
            {showDesignCredit
              ? "Copyright @ 2025. LAVANYA AND SHANKAR. All Rights Reserved. | Concept & Design by eparivartan"
              : "Copyright @ 2025. LAVANYA AND SHANKAR. All Rights Reserved."
            }
          </p>

          {/* Social Media Icons */}
          <div className="contactpage-social-icons">
            <a
              href="https://wa.me/919884072874"
              target="_blank"
              rel="noopener noreferrer"
              className="contactpage-icon-link whatsapp"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.instagram.com/lavanyaandshankar_architects?igsh=MW5uY3R5MmI3cmF6NA=="
              target="_blank"
              rel="noopener noreferrer"
              className="contactpage-icon-link instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/lavanya-shankar-architects/"
              target="_blank"
              rel="noopener noreferrer"
              className="contactpage-icon-link linkedin"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;